// Título de un hallazgo para el texto de una notificación.
//
// Es `description` y no `subject`: la tabla `tickets` NO tiene columna `subject`
// (42 columnas, verificado contra producción), así que `ticket.subject` era
// siempre undefined y toda asignación se anunciaba como "Sin asunto". `description`
// es el mismo campo que la tabla del inbox usa como título de la fila.
//
// Sin HTML y acortado, porque es texto libre: el más largo del histórico pasa los
// 9.000 caracteres y acá tiene que entrar en una línea de la campanita.
const MAX_TITULO = 80

export const tituloDelHallazgo = (ticket) => {
    const texto = (ticket?.description || '').replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim()
    if (!texto) return ''

    return texto.length > MAX_TITULO ? `${texto.slice(0, MAX_TITULO)}...` : texto
}

// `Hallazgo #123: lo que dice` cuando hay descripción, `Hallazgo #123` cuando no.
// Un hallazgo sin descripción es raro pero posible, y "Sin asunto" no aporta nada:
// es peor que no decir nada.
export const referenciaDelHallazgo = (ticket, alias, idPorDefecto = 'N/A') => {
    const titulo = tituloDelHallazgo(ticket)
    const id = ticket?.id ?? idPorDefecto

    return `${alias} #${id}${titulo ? `: ${titulo}` : ''}`
}
